import isRebrand from '@/utils/isRebrand';
import React, { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useScript } from '../hooks/useScript';
import { segmentTracking } from '../utils/segmentTracking';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.limoncello};
  /* height: 1px; */
  width: 1px;
`;

function Head(props) {
  const location = useLocation();
  useEffect(() => {
    (async () => {
      const _affirm_config = {
        public_api_key: window.affirmPublicApiKey,
        script: window.affirmScriptUrl
      };

      (function(l, g, m, e, a, f, b) {
        var d,
          c = l[m] || {},
          h = document.createElement(f),
          n = document.getElementsByTagName(f)[0],
          k = function(a, b, c) {
            return function() {
              a[b]._.push([c, arguments]);
            };
          };
        c[e] = k(c, e, 'set');
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);
        a = 0;
        for (
          b = 'set add save post open empty reset on off trigger ready setProduct'.split(
            ' '
          );
          a < b.length;
          a++
        )
          d[b[a]] = k(c, e, b[a]);
        a = 0;
        for (b = ['get', 'token', 'url', 'items']; a < b.length; a++)
          d[b[a]] = function() {};
        h.async = !0;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c;
      })(window, _affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');

      (function(c, b, f, k, a) {
        c[b] = c[b] || {};
        for (c[b].q = c[b].q || []; a < k.length; ) f(k[a++], c[b]);
      })(
        window,
        'extole',
        function(c, b) {
          b[c] =
            b[c] ||
            function() {
              b.q.push([c, arguments]);
            };
        },
        ['createZone'],
        0
      );
      extole.createZone({
        name: 'overlay',
        element_id: 'extole_zone_overlay'
      });

      (function() {
        var a = document.createElement('script');
        (a.type = 'text/javascript'),
          (a.async = !0),
          (a.src = '//container.pepperjam.com/1187413978.js');
        var b = document.getElementsByTagName('head')[0];
        if (b) b.appendChild(a, b);
        else {
          var b = document.getElementsByTagName('script')[0];
          b.parentNode.insertBefore(a, b);
        }
      })();



      //Start segment
      (function() {
        let analytics = (window.analytics = window.analytics || []);
        if (!analytics.initialize)
          if (analytics.invoked)
            window.console &&
            console.error &&
            console.error('Segment snippet included twice.');
          else {
            analytics.invoked = !0;
            analytics.methods = [
              'trackSubmit',
              'trackClick',
              'trackLink',
              'trackForm',
              'pageview',
              'identify',
              'reset',
              'group',
              'track',
              'ready',
              'alias',
              'debug',
              'page',
              'once',
              'off',
              'on'
            ];
            analytics.factory = function(t) {
              return function() {
                let e = Array.prototype.slice.call(arguments);
                e.unshift(t);
                analytics.push(e);
                return analytics;
              };
            };
            for (var i = 0; i < analytics.methods.length; i++) {
              let key = analytics.methods[i];
              analytics[key] = analytics.factory(key);
            }
            analytics.load = function(key, options) {
              var script = document.createElement('script');
              script.type = 'text/javascript';
              script.async = !0;
              script.src =
                'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
              var first = document.getElementsByTagName('script')[0];
              first.parentNode.insertBefore(script, first);
              analytics._loadOptions = options;
            };
            analytics.SNIPPET_VERSION = '4.1.0';
            analytics.load(window.segmentKey);
            analytics.page();
          }
      }());
      //End segment


      // Pinterest tracking
      if (window.environment == 'production') {
        !(function(e) {
          if (!window.pintrk) {
            window.pintrk = function() {
              window.pintrk.queue.push(Array.prototype.slice.call(arguments));
            };
            var n = window.pintrk;
            (n.queue = []), (n.version = '3.0');
            var t = document.createElement('script');
            (t.async = !0), (t.src = e);
            var r = document.getElementsByTagName('script')[0];
            r.parentNode.insertBefore(t, r);
          }
        })('https://s.pinimg.com/ct/core.js');
        if (props.isAuthenticated && props.user.email) {
          pintrk('load', '2614133037640', {
            em: props.user.email
          });
        } else {
          pintrk('load', '2614133037640');
        }

        pintrk('page');
      }
      // End Pinterest Tracking

      // Bing UET tracking
      (function(w, d, t, r, u) {
        var f, n, i;
        (w[u] = w[u] || []),
          (f = function() {
            var o = { ti: BingId };
            (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange = function() {
            var s = this.readyState;
            (s && s !== 'loaded' && s !== 'complete') ||
              (f(), (n.onload = n.onreadystatechange = null));
          }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i);
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
      // End Bing UET tracking

      // Start WKND tag.
      (function(d) {
        var e = d.createElement('script');
        e.src = d.location.protocol + '//tag.wknd.ai/4207/i.js';
        e.async = true;
        d.getElementsByTagName('head')[0].appendChild(e);
      })(document);
      //End WKND tag
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!window.isPrerender) {
        if (typeof window !== 'undefined') {
          ReactPixel.init(
            FAId,
            {},
            {
              autoConfig: true, // set pixel's autoConfig
              debug: false // enable logs
            }
          );
          ReactPixel.pageView();
        }
      }
      if (!window.isFirstPageLoad) {
        setTimeout(() => {
          window.dataLayer = window.dataLayer || [];
          const gaPageViewPayload = {
            event: 'gaPageView',
            virtualPageviewPath: location.pathname,
            virtualPageviewTitle: document.title
          };
          window.dataLayer.push(gaPageViewPayload);

          window.uetq = window.uetq || [];
          window.uetq.push('event', 'page_view', {
            page_path: location.pathname
          });
        }, 200);
      } else {
        window.isFirstPageLoad = false;
      }

      // For segment.com
      // we need the setTimeout to have the .page method to pull the right data like path, or title.
      setTimeout(() => {
        segmentTracking({ ...props, location });
      }, 200);
    })();
  }, [location.pathname]);

  const [extoleLoaded, extoleError] = useScript(
    'https://the-inside.extole.io/core.js'
  );

  const removeLastSlash = myString => {
    if (myString.charAt(myString.length - 1) === '/') {
      return (myString = myString.substr(0, myString.length - 1));
    } else {
      return myString;
    }
  };

  const getCanonical = pathname => {
    return removeLastSlash(
      `https://www.theinside.com${pathname}`.toLowerCase()
    );
  };

  const isNotPrerenderOrLightHouse =
    !window.isPrerender && !window.isLightHouse;

  const [unbounce, errorUnbounce] = isNotPrerenderOrLightHouse
    ? useScript('https://9ba9eda0b4b045519bddd98db7be5ad9.js.ubembed.com')
    : [null, null];

  return (
    <Wrapper>
      <Helmet>
        <link rel="canonical" href={getCanonical(location.pathname)} />
      </Helmet>
      {isNotPrerenderOrLightHouse && (
        <div className="d-none">
          <iframe
            title="Pepperjam"
            src="//nojscontainer.pepperjam.com/1187413978.html"
            width="1"
            height="1"
            frameBorder="0"
          />
        </div>
      )}
    </Wrapper>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(Head);
